import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { loginAction, cleanError } from "../redux/actions/login";
import strings from "../i18n/language";
const packageJson = require("../../package.json");

const BRAND = '#3b95e8';
const MUTED = 'rgba(232,240,254,0.45)';
const BORDER = 'rgba(255,255,255,0.10)';

const inputStyle = {
  width: '100%',
  padding: '14px 16px',
  background: 'rgba(255,255,255,0.06)',
  border: `1px solid ${BORDER}`,
  borderRadius: 12,
  color: '#e8f0fe',
  fontSize: 15,
  fontFamily: 'system-ui, -apple-system, sans-serif',
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 0.2s',
};

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [focusedField, setFocusedField] = useState(null);
  const error = useSelector((state) => state.login.error);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!username || !username.trim()) {
      toast.error(strings.ERROR_ENTER_NAME);
    } else if (!password || !password.trim()) {
      toast.error(strings.ERROR_ENTER_PASSWORD);
    } else {
      dispatch(loginAction({ email: username, password }));
    }
  };

  useEffect(() => {
    if (error) {
      if (error === 'USER_NOT_FOUND') toast.error(strings.ERROR_USER_NOT_FOUND);
      dispatch(cleanError());
    }
  }, [dispatch, error]);

  return (
    <>
      <style>{`
        html, body { margin: 0; padding: 0; }
        input::placeholder { color: rgba(232,240,254,0.3); }
        input:-webkit-autofill {
          -webkit-box-shadow: 0 0 0 1000px rgba(30,58,95,0.9) inset !important;
          -webkit-text-fill-color: #e8f0fe !important;
        }
      `}</style>
      <ToastContainer position="bottom-right" />

      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(160deg, #0a1628 0%, #0f1f3d 50%, #0a1628 100%)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        padding: '24px',
        boxSizing: 'border-box',
        position: 'relative',
      }}>

        {/* Glow */}
        <div style={{
          position: 'absolute', top: '40%', left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500, height: 500, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(59,149,232,0.10) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />

        {/* Back button */}
        <button
          onClick={() => navigate('/')}
          style={{
            position: 'fixed', top: 20, left: 20, zIndex: 10,
            display: 'flex', alignItems: 'center', gap: 6,
            background: 'rgba(255,255,255,0.07)',
            color: 'rgba(232,240,254,0.7)',
            border: `1px solid ${BORDER}`,
            borderRadius: 10, padding: '8px 16px',
            fontSize: 13, fontWeight: 600, cursor: 'pointer',
            backdropFilter: 'blur(8px)',
          }}>
          ← Volver
        </button>

        {/* Card */}
        <div style={{
          width: '100%', maxWidth: 400,
          background: 'rgba(255,255,255,0.04)',
          border: `1px solid ${BORDER}`,
          borderRadius: 24,
          padding: '40px 36px',
          boxSizing: 'border-box',
          position: 'relative',
        }}>

          {/* Logo + title */}
          <div style={{ textAlign: 'center', marginBottom: 36 }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
              <div style={{
                width: 56, height: 56, borderRadius: 16,
                background: 'linear-gradient(135deg, #3b95e8 0%, #1a6fc4 100%)',
                boxShadow: '0 6px 24px rgba(59,149,232,0.45)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <span style={{ fontFamily: 'FingerPaint, serif', fontSize: 30, color: '#fff', lineHeight: 1, marginTop: 2 }}>f</span>
              </div>
            </div>
            <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 2, color: BRAND, textTransform: 'uppercase', marginBottom: 6 }}>
              Fidelize
            </div>
            <div style={{ fontSize: 13, color: MUTED }}>Acceso para negocios</div>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} noValidate>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: MUTED, marginBottom: 6, letterSpacing: 0.4 }}>
                Correo electrónico
              </label>
              <input
                type="email"
                autoComplete="off"
                autoFocus
                value={username}
                onChange={e => setUsername(e.target.value)}
                onFocus={() => setFocusedField('email')}
                onBlur={() => setFocusedField(null)}
                style={{
                  ...inputStyle,
                  borderColor: focusedField === 'email' ? BRAND : BORDER,
                }}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: MUTED, marginBottom: 6, letterSpacing: 0.4 }}>
                Contraseña
              </label>
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                onFocus={() => setFocusedField('password')}
                onBlur={() => setFocusedField(null)}
                style={{
                  ...inputStyle,
                  borderColor: focusedField === 'password' ? BRAND : BORDER,
                }}
              />
            </div>

            <button
              type="submit"
              style={{
                width: '100%',
                padding: '14px',
                background: BRAND,
                color: '#fff',
                border: 'none',
                borderRadius: 12,
                fontSize: 15,
                fontWeight: 700,
                cursor: 'pointer',
                letterSpacing: 0.3,
                boxShadow: '0 6px 24px rgba(59,149,232,0.35)',
                marginBottom: 20,
              }}>
              {strings.LABEL_BUTTON_SIGNIN}
            </button>

            <div style={{ textAlign: 'center' }}>
              <a href="/forgot" style={{ fontSize: 13, color: MUTED, textDecoration: 'none' }}>
                Olvidé mi contraseña
              </a>
            </div>
          </form>
        </div>

        {/* Version */}
        <div style={{ position: 'fixed', bottom: 16, right: 20 }}>
          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.15)' }}>v{packageJson.version}</span>
        </div>
      </div>
    </>
  );
}

export default Login;
